import { createColumnHelper } from '@tanstack/react-table';

import { NodePlacementRowData } from '../../types';

export const columnHelper = createColumnHelper<NodePlacementRowData>();
